import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { autorun } from 'mobx';
import { v4 as uuidv4 } from 'uuid';
import {
  Segment,
  Dimmer,
  Loader,
  Label,
  Icon,
  Header,
  List,
  Pagination,
  Input,
  Modal,
  Message,
  Popup,
  Button,
} from 'semantic-ui-react';
import cx from 'classnames';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import Footer from '../Footer/Footer';
import api from '../../api';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import closeBtn from '../../images/components/content_wide_card/closeBtn.png';
import ScannedFilesInfoModal from '../Modal/ScannedFilesInfoModal';
import WithRouter from '../Extensions/WithRouter';
import RenderProjectTree from '../Extensions/RenderProjectTree';
import CNVDRow from './CNVDRow';

class SecurityDetail extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.smallBody = null;
    this.viewRef = React.createRef();
    const { state, params } = this.props;
    this.state = {
      pageSize: state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      viewMode: state.user.view_mode,
      cnvdList: [],
      error: null,
      isLoading: false,
      isDetailLoading: false,
      isVisible: '',
      hasMore: false,
      activeIndex: [],
      popupIndex: [],
      securityTreeData: [],
      filter: [],
      searchKeyword: '',
      isSort: false,
      popupType: '',
      sortValue: '2',
      idReport: params.idReport,
      isOpenMSF: false,
      scannedFileIds: [],
      activePage: '',
      pdfElement: '',
      isRenderListOnly: false,
      isOpenWarnModal: false,
      totalCount: 0,
      isOnline: navigator.onLine,
      isPageLoading: false,

    };
  }

  componentDidMount() {
    const { state } = this.props;
    window.addEventListener('scroll', this.handleOnScroll);
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 140) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });

    this.disposeUserReaction = autorun(() => {
      this.setState({
        viewMode: state.user.view_mode,
        pageSize: state.user.page_limit,
      });
    });

    this.onUpdateLoading();
    this.renderPopup();
    document.addEventListener('mousedown', this.handleClickOutside);
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps, prevState) {
    const { params } = this.props;
    const { isPageLoading } = this.state;

    if (prevState.isLoading !== isPageLoading && isPageLoading) {
      this.getCNVDList();
      this.setState({
        isPageLoading: false,
      });
    }

    if (prevProps.params.idReport !== params.idReport) {
      this.setState(
        {
          idReport: params.idReport,
          cnvdList: [],
        },
        () => {
          this.getCNVDList();
        }
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    document.removeEventListener('mousedown', this.handleClickOutside);

    if (this.disposeUserReaction) {
      this.disposeUserReaction();
    }
  }

  handleActivePageChange = (e) => {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        cnvdList: [],
        activeIndex: [],
        currentPage: activePage,
      }, () => {
        this.getCNVDList(activePage, pageSize);
      });
    }
  };

  handleSearchChange = (value) => {
    this.setState({
      searchKeyword: value,
    });
  };

  handleInputActivePageChange = (e, { value }) => {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  };

  handleOnScroll = () => {
    const {
      getCNVDList,
      state: {
        error, isLoading, hasMore, viewMode, currentPage
      },
    } = this;

    if (viewMode === 'list') {
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getCNVDList(currentPage + 1);
    }
  };

  handleChange = (value) => {
    this.setState(
      {
        searchKeyword: value,
        cnvdList: [],
        activeIndex: [],
      },
      () => {
        this.getCNVDList();
      }
    );
  };

  handleFilterData = (value) => {
    this.setState(
      {
        cnvdList: [],
        activeIndex: [],
        filter: value.filter,
      },
      () => {
        this.getCNVDList();
      }
    );
  };

  handleMoreInfo = (index, type) => {
    const { popupIndex } = this.state;
    let newState;

    if (popupIndex.indexOf(index) === -1) {
      newState = [...popupIndex, index];
    } else {
      newState = popupIndex;
    }

    this.setState({
      popupIndex: newState,
      popupType: type,
    });
  };

  handleOtherRisk = (index, ids) => {
    const { popupIndex } = this.state;
    let newState;

    if (popupIndex.indexOf(index) === -1) {
      newState = [...popupIndex, index];
    } else {
      newState = popupIndex;
    }

    this.setState(
      {
        popupIndex: newState,
        popupType: 'type_1',
      },
      () => {
        this.getProjectTree(ids);
      }
    );
  };

  handlePopupClose = (index) => {
    const { popupIndex } = this.state;
    const newState = popupIndex.filter((i) => {
      return i !== index;
    });

    this.setState({
      popupIndex: newState,
      popupType: '',
    });
  };

  handleClickOutside = (event) => {
    const { popupIndex, popupType } = this.state;
    const container = $('.card_detail_popup .popup_box');
    if (container && container.has(event.target).length === 0) {
      if (popupIndex.length !== 0 && popupType !== '') {
        this.setState({
          popupIndex: '',
          popupType: '',
        });
        return true;
      }
      return false;
    }
  };

  handleMSFClose = () => {
    this.setState({
      isOpenMSF: false,
    });
  };

  handlePageSizeChange = (value) => {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        cnvdList: [],
        activeIndex: [],
      },
      () => {
        this.getCNVDList();
      }
    );
  };

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      cnvdList: [],
      activeIndex: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getCNVDList(activePage, pageSize);
    });
  };

  handleNavigateToNvd = (cveCode) => {
    const { isOnline } = this.state;
    if (isOnline) {
      const match = cveCode.match(/CVE-\d{4}-\d{4,7}/);
      const extractedCveCode = match ? match[0] : '';

      if (extractedCveCode) {
        window.open(`https://nvd.nist.gov/vuln/detail/${extractedCveCode}`, '_blank');
      } else {
        console.error('Invalid CVE code');
      }
    }
  };

  handleNavigateToCnvd = (cnvd) => {
    const { isOnline } = this.state;
    if (isOnline) {
      const match = cnvd.match(/CNVD-\d{4}-\d{5,7}/);
      const extractedCveCode = match ? match[0] : '';

      if (extractedCveCode) {
        window.open(`https://www.cnvd.org.cn/flaw/show/${extractedCveCode}`, '_blank');
      } else {
        console.error('Invalid CNVD ID');
      }
    }
  };

  onUpdateLoading = () => {
    this.setState({
      isPageLoading: true,
    });
  };

  onChangeSorting = (e) => {
    const { isSort, sortValue } = this.state;

    if (e.currentTarget.dataset.id !== sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          cnvdList: [],
          activeIndex: [],
        },
        () => {
          this.getCNVDList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          cnvdList: [],
          activeIndex: [],
        },
        () => {
          this.getCNVDList();
        }
      );
    }
  };

  setPrecisionLevel = (value) => {
    const { state } = this.props;
    this.setState({
      cnvdList: [],
      activeIndex: [],
    }, () => {
      state.user.setPrecisionLevel(value);
      this.getCNVDList();
    });
  };

  getCNVDList = async (pageNo, limit) => {
    try {
      const {
        isSort, sortValue, cnvdList, pageSize, filter, searchKeyword, idReport
      } = this.state;
      const { state } = this.props;
      const { user } = state;

      const page = pageNo || 1;
      const perPage = limit || pageSize || user.page_limit || localStorage.getItem('page_limit');

      const precisionLevel = user.currentPrecisionLevel || null;

      const filterData = filter.length ? filter.join(',') : '';

      const sortMap = {
        1: 'cnvd_name',
        2: 'risk',
        3: 'cve',
        4: 'component_count',
        5: 'component_version_count',
        6: 'scanned_file_count',
      };
      const baseSortField = sortMap[sortValue] || 'risk';
      const order = isSort ? `${baseSortField}_r` : baseSortField;

      this.setState({ isLoading: true });

      const response = await api.getCNVDList(
        {
          search: searchKeyword,
          filter: filterData,
          page,
          limit: perPage,
          order,
          precision_level: precisionLevel,
        },
        idReport
      );

      if (cnvdList.length !== 0 && response.pagination.current === 1) {
        this.setState({ isLoading: false });
        return;
      }

      const nextCnvdList = response.response.map((item) => {
        return {
          uploadedFileId: item.uploaded_file_id,
          codeName: item.code,
          riskGrade: item.risk,
          cves: item.cves,
          componentCount: item.component_count,
          componentVersionCount: item.component_version_count,
          scannedFileCount: item.scanned_file_count,
        };
      });

      this.setState({
        currentPage: response.pagination.current,
        pageSize: response.pagination.per_page,
        totalPage: response.pagination.pages,
        totalCount: response.pagination.count,
        hasMore: response.pagination.next !== null,
        isLoading: false,
        cnvdList: [...cnvdList, ...nextCnvdList],
      });
    } catch (err) {
      const { t } = this.props;
      console.error(err);
      this.setState({
        error: t('modal.error.error_load'),
        isLoading: false,
      });
    }
  };

  getCNVDDetail = (cnvdName) => {
    const { t, state } = this.props;
    const { idReport } = this.state;
    let precisionLevel;

    if (state.user.currentPrecisionLevel) {
      precisionLevel = state.user.currentPrecisionLevel;
    } else {
      precisionLevel = null;
    }

    this.setState({
      isDetailLoading: true,
      isVisible: cnvdName,
    }, () => {
      api
        .getCNVDDetail(
          {
            cnvd_name: cnvdName,
            precision_level: precisionLevel,
          },
          idReport
        )
        .then((response) => {
          const { cnvdList } = this.state;
          const data = response.response;
          const updatedIndex = cnvdList.findIndex((item) => {
            return item.codeName === cnvdName;
          });
          const updatedData = Update(cnvdList[updatedIndex], {
            cnvdDetail: { $set: data },
          });
          const newData = Update(cnvdList, {
            $splice: [[updatedIndex, 1, updatedData]],
          });
          this.setState({
            cnvdList: newData,
            isDetailLoading: false,
            isVisible: '',
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            error: t('modal.error.error_load'),
            isDetailLoading: false,
            isVisible: '',
          });
        });
    });
  };

  getProjectTree = (ufid) => {
    const { t } = this.props;
    const value = JSON.parse(`[${ufid}]`);
    const obj = {
      uploaded_file_ids: value,
    };
    api
      .getProjectTree(obj)
      .then((response) => {
        const data = response.response;
        this.setState({
          securityTreeData: data,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
        });
      });
  };

  createElementWithCanvas = () => {
    const { t } = this.props;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const tableEl = clonedObject.getElementsByClassName('wide_card_box');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');

        if (expandTableEl.length !== 0) {
          this.modalBody = t('modal.message.clraity_report_main_warn');
          this.smallBody = t('modal.message.clarity_reporty_sub_warn');
          return this.setState({
            isOpenWarnModal: true,
          });
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }

        //wide_card_box wide_card_type_01
        if (tableEl.length > 15) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 14 && tableEl.length > 15) || (i > 15 && (i - 14) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderListOnly: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderListOnly: false,
    });
  };

  toggleRow = (index, codeName) => {
    const { activeIndex } = this.state;
    let newState;

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      this.getCNVDDetail(codeName);
      newState = [...activeIndex, index];
    }
    this.setState({ activeIndex: newState });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      cnvdList: [],
      activeIndex: [],
    }, () => {
      this.getCNVDList();
    });
  };

  closeModal = () => {
    this.modalBody = null;
    this.smallBody = null;
    this.setState({
      isOpenWarnModal: false,
    });
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        cnvdList: [],
        activeIndex: [],
        filter: newState,
      },
      () => {
        this.getCNVDList();
      }
    );
  };

  clearAllValue = () => {
    this.setState(
      {
        cnvdList: [],
        activeIndex: [],
        filter: [],
      },
      () => {
        this.getCNVDList();
      }
    );
  };

  clearSearch = () => {
    this.setState(
      {
        searchKeyword: '',
        cnvdList: [],
        activeIndex: [],
      },
      () => {
        this.getCNVDList();
      }
    );
  };

  renderValue = () => {
    const { filter } = this.state;
    const { t } = this.props;

    const cnvdFilter = filter.filter((item) => {
      return item.indexOf('cnvd') > -1;
    });

    const filterObj = { cnvd: cnvdFilter, };

    return (
      <div>
        {filterObj.cnvd.length !== 0 && (
          <Label.Group>
            <span>
              <strong>CNVD</strong>
            </span>
            {filterObj.cnvd.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_h') > -1 && 'High'}
                  {item.indexOf('_m') > -1 && 'Medium'}
                  {item.indexOf('_l') > -1 && 'Low'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filter.length !== 0 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
            onKeyUp={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  };

  renderPopup = () => {
    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tac', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    $(document).on('mouseover', '.card_detail_popup .table_type_1 .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  };

  renderCvesCell = (cves) => {
    const { t } = this.props;
    const displayLimit = 1;
    const showMore = cves.length > displayLimit;

    if (!cves || cves.length === 0) {
      return (
        <div>
          <span>N/A</span>
        </div>
      );
    }

    if (!showMore) {
      return (
        <div>
          {cves.map((cve) => {
            return (
              <span key={cve}>
                {cve}
              </span>
            );
          })}
        </div>
      );
    }

    const initialCves = cves.slice(0, displayLimit);
    const moreCvesCount = cves.length - displayLimit;

    return (
      <div>
        {initialCves.map((cve, index) => {
          return (
            <span key={cve}>
              {cve}
              {index < initialCves.length - 1 && ', '}
            </span>
          );
        })}
        <Popup
          trigger={(
            <Button
              as="a"
              size="mini"
              basic
              compact
              content={t('modal.title.view_more_cves', { count: moreCvesCount })}
              style={{ marginLeft: '5px' }}
              onClick={(e) => { return e.stopPropagation(); }}
            />
          )}
          on="click"
          position="bottom center"
          flowing
          hoverable
        >
          <Segment inverted color="grey">
            <List divided inverted relaxed>
              {cves.map((cve) => {
                return (
                  <List.Item key={cve}>
                    <List.Content>
                      <List.Header>{cve}</List.Header>
                    </List.Content>
                  </List.Item>
                );
              })}
            </List>
          </Segment>
        </Popup>
      </div>
    );
  };

  render() {
    const {
      error,
      hasMore,
      isLoading,
      cnvdList,
      activeIndex,
      securityTreeData,
      isSort,
      sortValue,
      filter,
      popupType,
      popupIndex,
      isDetailLoading,
      isVisible,
      viewMode,
      pageSize,
      currentPage,
      totalPage,
      activePage,
      pdfElement,
      searchKeyword,
      totalCount,
      isOnline,
      isRenderListOnly,
      isOpenMSF,
      idReport,
      scannedFileIds,
      isOpenWarnModal,
    } = this.state;

    const {
      location, state, params, t, navigate
    } = this.props;

    return (
      <div className="result_file">
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          filter={filter}
          totalCount={totalCount}
          handlePrecisionLevel={this.setPrecisionLevel}
          viewMode={viewMode}
          pageSize={pageSize}
          handlePageSizeChange={this.handlePageSizeChange}
          toggleViewMode={this.toggleViewMode}
          refElement={pdfElement}
          currentPage={currentPage}
          isRenderListOnly={isRenderListOnly}
          createElementWithCanvas={this.createElementWithCanvas}
          generatePdfCallback={this.generatePdfCallback}
          location={location}
          state={state}
          params={params}
          translate={t}
          navigate={navigate}
          searchKeyword={searchKeyword}
          handleSearchChange={this.handleSearchChange}
        />
        <div className="content">
          {filter.length !== 0 ? <div className="tag_list">{this.renderValue()}</div> : null}
          <div className="wide_card_wrap">
            <div className="table_header">
              <div className="table_header_inner">
                <table className="wide_card_table wide_card_scope">
                  <colgroup>
                    <col style={{ width: '3.9%', maxWidth: '36px' }} />
                    <col style={{ width: '13%', maxWidth: '120px' }} />
                    <col style={{ width: '9.1%', maxWidth: '84px' }} />
                    <col style={{ width: '13%', maxWidth: '120px' }} />
                    <col style={{ width: '17.8%' }} />
                    <col style={{ width: '17.8%' }} />
                    <col style={{ width: '17.8%' }} />
                    <col style={{ width: '4.3%', maxWidth: '40px' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <th className="checkbox_wrap tal">
                        <div className="checkbox" />
                      </th>
                      <th className="tac">
                        <a
                          className="sorting_button"
                          data-id="1"
                          onClick={this.onChangeSorting}
                          onKeyUp={this.onChangeSorting}
                        >
                          {t('modal.title.cnvd_code')}
                          {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th className="tac">
                        <a
                          className="sorting_button"
                          data-id="2"
                          onClick={this.onChangeSorting}
                          onKeyUp={this.onChangeSorting}
                        >
                          {t('chart.title.severity')}
                          {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th className="tal">
                        <a
                          className="sorting_button"
                          data-id="3"
                          onClick={this.onChangeSorting}
                          onKeyUp={this.onChangeSorting}
                        >
                          {t('modal.title.related_cves')}
                          {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th className="tac">
                        <a
                          className="sorting_button"
                          data-id="4"
                          onClick={this.onChangeSorting}
                          onKeyUp={this.onChangeSorting}
                        >
                          {t('list.title.component')}
                          {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th className="tac">
                        <a
                          className="sorting_button"
                          data-id="5"
                          onClick={this.onChangeSorting}
                          onKeyUp={this.onChangeSorting}
                        >
                          {t('list.title.component_version')}
                          {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th className="tac">
                        <a
                          className="sorting_button"
                          data-id="6"
                          onClick={this.onChangeSorting}
                          onKeyUp={this.onChangeSorting}
                        >
                          {t('contents_header.place_holder.scanned_file_name')}
                          {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : ''}
                          {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : ''}
                        </a>
                      </th>
                      <th>&nbsp;</th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {cnvdList.map((item, index) => {
              return (
                <div
                  className={cx(
                    'wide_card_box wide_card_type_03',
                    {
                      expand: activeIndex.indexOf(index) >= 0,
                    },
                    {
                      card_detail_popup_show: popupIndex.indexOf(index) >= 0,
                    },
                    {
                      type_0: popupType === 'type_0',
                    },
                    {
                      type_1: popupType === 'type_1',
                    },
                    {
                      type_2: popupType === 'type_2',
                    },
                    {
                      type_3: popupType === 'type_3',
                    },
                    {
                      red: item.riskGrade === 'critical'
                    },
                    {
                      orange: item.riskGrade === 'high'
                    },
                    {
                      cheese: item.riskGrade === 'medium'
                    },
                    {
                      yellow: item.riskGrade === 'low'
                    }
                  )}
                  key={item.codeName.toString()}
                >
                  <table className="wide_card_table wide_card_item">
                    <colgroup>
                      <col style={{ width: '3.9%', maxWidth: '36px' }} />
                      <col style={{ width: '13%', maxWidth: '120px' }} />
                      <col style={{ width: '9.1%', maxWidth: '84px' }} />
                      <col style={{ width: '13%', maxWidth: '120px' }} />
                      <col style={{ width: '48.3%' }} />
                      <col style={{ width: '4.3%', maxWidth: '40px' }} />
                    </colgroup>
                    <tbody>
                      <tr
                        className="sum_line"
                        onClick={() => {
                          return this.toggleRow(index, item.codeName);
                        }}
                      >
                        <td className="checkbox_wrap border-none tal">
                          <div className="checkbox" />
                        </td>
                        <td className="border-none tac">
                          <strong>{item.codeName}</strong>
                        </td>
                        <td className="border-none tac">{item.riskGrade}</td>
                        <td className="border-none tal">
                          {this.renderCvesCell(item.cves)}
                        </td>
                        <td className="sum_td" colSpan="3">
                          <table className="wide_card_table wide_card_item">
                            <colgroup>
                              <col style={{ width: '33.3%' }} />
                              <col style={{ width: '33.3%' }} />
                              <col style={{ width: '33.3%' }} />
                            </colgroup>
                            <tbody>
                              <tr>
                                <td className="tac">{item.componentCount}</td>
                                <td className="tac">{item.componentVersionCount}</td>
                                <td className="tac">{item.scannedFileCount}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        <td className="border-none tac">
                          <a
                            className="expand_button"
                          >
                            <img src={expandBtn} alt="" />
                          </a>
                        </td>
                      </tr>
                      {
                        isDetailLoading && isVisible === item.codeName ? (
                          <tr>
                            <td className="border-none" colSpan="7">
                              <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                <Loader active={isDetailLoading && isVisible === item.codeName} inline="centered" />
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <tr className="extend_item">
                            <td className="checkbox_wrap border-none tal">&nbsp;</td>
                            <td className="border-none tal">&nbsp;</td>
                            <td className="border-none tal">&nbsp;</td>
                            <td className="border-none tal">&nbsp;</td>
                            <td className="border-none sum_td" colSpan="3">
                              {
                                item.cnvdDetail
                                && (
                                  <CNVDRow
                                    childRef={this.viewRef}
                                    rowData={item.cnvdDetail}
                                    uid={item.uploadedFileId}
                                    t={t}
                                    state={state}
                                    location={location}
                                    params={params}
                                  />
                                )
                              }
                            </td>
                            <td className="border-none tal">&nbsp;</td>
                          </tr>
                        )
                      }
                    </tbody>
                  </table>
                  {item.cnvdDetail ? (
                    <div className="wide_card_detail">
                      <div className="wide_card_detail_top type_description" style={{ height: '266px', position: 'relative' }}>
                        <div className="foo" style={{ marginTop: '18px', position: 'absolute', bottom: '0' }} />
                        <div className="version_text" style={{ position: 'absolute', bottom: '3px', right: '5px' }} />
                      </div>
                      <div className="wide_card_detail_bottom">
                        <a
                          className={cx('card_detail_popup_show', {
                            active: popupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                          })}
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            return this.handleMoreInfo(index, 'type_0');
                          }}
                          onKeyUp={() => {
                            return this.handleMoreInfo(index, 'type_0');
                          }}
                        >
                          {t('list.title.more_information')}
                        </a>
                        {
                          item.cnvdDetail.patch_info && (
                            <a
                              className={cx('card_detail_popup_show', {
                                active: popupIndex.indexOf(index) >= 0 && popupType === 'type_2',
                              })}
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                return this.handleMoreInfo(index, 'type_2');
                              }}
                              onKeyUp={() => {
                                return this.handleMoreInfo(index, 'type_2');
                              }}
                            >
                              {t('list.title.patch_information')}
                            </a>
                          )
                        }
                        {
                          item.cnvdDetail.cves && item.cnvdDetail.cves.length !== 0 && (
                            <a
                              className={cx('card_detail_popup_show', {
                                active: popupIndex.indexOf(index) >= 0 && popupType === 'type_3',
                              })}
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                return this.handleMoreInfo(index, 'type_3');
                              }}
                              onKeyUp={() => {
                                return this.handleMoreInfo(index, 'type_3');
                              }}
                            >
                              {t('modal.title.related_cves')}
                            </a>
                          )
                        }
                        <a
                          className={cx('card_detail_popup_show', {
                            active: popupIndex.indexOf(index) >= 0 && popupType === 'type_1',
                          })}
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            return this.handleOtherRisk(
                              index,
                              item.cnvdDetail.uploaded_file_ids
                            );
                          }}
                          onKeyUp={() => {
                            return this.handleOtherRisk(
                              index,
                              item.cnvdDetail.uploaded_file_ids
                            );
                          }}
                        >
                          {t('list.title.other_file_risk')}
                        </a>
                      </div>
                    </div>
                  ) : null}
                  {item.cnvdDetail && popupType === 'type_0' && (
                    <div className="card_detail_popup card_detail_popup_1 security">
                      <div className="popup_box">
                        <h3 className="popup_header">
                          {t('list.title.more_information')}
                          {item.cnvdDetail.more_info && (
                            <span>
                              {' - '}
                              <a
                                className={cx(
                                  'nvd_link',
                                  {
                                    online: isOnline,
                                  }
                                )}
                                onClick={isOnline ? () => { return this.handleNavigateToCnvd(item.cnvdDetail.more_info.cnvd); } : null}
                                onKeyUp={isOnline ? () => { return this.handleNavigateToCnvd(item.cnvdDetail.more_info.cnvd); } : null}
                              >
                                {item.cnvdDetail.more_info.cnvd}
                              </a>
                            </span>
                          )}
                          <a
                            className="card_detail_popup_hide"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handlePopupClose(index);
                            }}
                            onKeyUp={() => {
                              return this.handlePopupClose(index);
                            }}
                          >
                            <img src={closeBtn} alt="" />
                          </a>
                        </h3>
                        <div className="popup_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            <div className="type_3 ">
                              {
                                item.cnvdDetail.more_info
                                && (
                                  <Segment raised>
                                    <Label attached="top left" className="more_info_name">
                                      {t('modal.cve.vuln_name')}
                                    </Label>
                                    <Header as="h3" style={{ marginTop: '20px' }}>
                                      {' '}
                                      <span>{item.cnvdDetail.more_info.title}</span>
                                      {' '}
                                    </Header>
                                  </Segment>
                                )
                              }
                              {
                                item.cnvdDetail.more_info
                                && <Message header={t('list.title.description')} content={item.cnvdDetail.more_info.description} />
                              }
                              {/*
                                item.cnvdDetail.more_info && (
                                  <Card.Group>
                                    <Card>
                                      <Card.Content>
                                        <Card.Header>{t('modal.cve.cvss_v2')}</Card.Header>
                                        <Card.Meta>{item.cnvdDetail.more_info.vectorv2}</Card.Meta>
                                        <Card.Description>
                                          <List>
                                            <List.Item>
                                              <List.Header>{t('modal.cve.base_score')}</List.Header>
                                              <List.Content style={{ fontWeight: '500' }}>{item.cnvdDetail.more_info.scorev2}</List.Content>
                                            </List.Item>
                                            <List.Item>
                                              <List.Header>{t('modal.cve.access_vector')}</List.Header>
                                              <List.Content>{item.cnvdDetail.more_info.access_vector}</List.Content>
                                            </List.Item>
                                            <List.Item>
                                              <List.Header>{t('modal.cve.access_complexity')}</List.Header>
                                              <List.Content>{item.cnvdDetail.more_info.accesscomplexity}</List.Content>
                                            </List.Item>
                                            <List.Item>
                                              <List.Header>{t('modal.cve.authentication')}</List.Header>
                                              <List.Content>{item.cnvdDetail.more_info.authentication}</List.Content>
                                            </List.Item>
                                            <List.Item>
                                              <List.Header>{t('modal.cve.confidentiality')}</List.Header>
                                              <List.Content>{item.cnvdDetail.more_info.confidentialityimpact}</List.Content>
                                            </List.Item>
                                            <List.Item>
                                              <List.Header>{t('modal.cve.integrity')}</List.Header>
                                              <List.Content>{item.cnvdDetail.more_info.integrityimpact}</List.Content>
                                            </List.Item>
                                            <List.Item>
                                              <List.Header>{t('modal.cve.availability')}</List.Header>
                                              <List.Content>{item.cnvdDetail.more_info.availabilityimpact}</List.Content>
                                            </List.Item>
                                          </List>
                                        </Card.Description>
                                      </Card.Content>
                                    </Card>
                                  </Card.Group>
                                )
                              */}
                              <dl>
                                <dt>{t('chart.title.severity')}</dt>
                                <dd>{item.cnvdDetail.more_info.severity}</dd>
                              </dl>
                              <dl>
                                <dt>{t('modal.cve.vuln_type')}</dt>
                                <dd>{item.cnvdDetail.more_info.vulntype}</dd>
                              </dl>
                              <dl>
                                <dt>{t('modal.cve.submit_date')}</dt>
                                <dd>{item.cnvdDetail.more_info.submittime}</dd>
                              </dl>
                              <dl>
                                <dt>{t('modal.cve.published_date')}</dt>
                                <dd>{item.cnvdDetail.more_info.publishtime}</dd>
                              </dl>
                              {
                                item.cnvdDetail.more_info.products && item.cnvdDetail.more_info.products.length !== 0 ? (
                                  <dl>
                                    <dt>{t('modal.cve.vuln_product')}</dt>
                                    <List>
                                      {item.cnvdDetail.more_info.products.map((url) => {
                                        return (
                                          <List.Item className="patch_url" key={uuidv4()}>
                                            <List.Content>
                                              {url}
                                            </List.Content>
                                          </List.Item>
                                        );
                                      })}
                                    </List>
                                  </dl>
                                ) : null
                              }
                              {
                                item.cnvdDetail.more_info.reference && item.cnvdDetail.more_info.reference !== ''
                                && <div className="line" />
                              }
                              {
                                item.cnvdDetail.more_info.reference && item.cnvdDetail.more_info.reference !== '' ? (
                                  <dl>
                                    <dt>{t('modal.cve.references')}</dt>
                                    <List>
                                      <List.Item className="patch_url">
                                        <List.Content>
                                          <a href={item.cnvdDetail.more_info.reference} target="_blank" rel="noopener noreferrer">
                                            {item.cnvdDetail.more_info.reference}
                                          </a>
                                        </List.Content>
                                      </List.Item>
                                    </List>
                                  </dl>
                                ) : null
                              }
                            </div>
                          </Scrollbars>
                        </div>
                      </div>
                    </div>
                  )}
                  {securityTreeData.length !== 0 && popupType === 'type_1' && (
                    <div className="card_detail_popup card_detail_popup_2">
                      <div className="popup_box">
                        <h3 className="popup_header">
                          <a
                            className="card_detail_popup_hide"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handlePopupClose(index);
                            }}
                            onKeyUp={() => {
                              return this.handlePopupClose(index);
                            }}
                          >
                            <img src={closeBtn} alt="" />
                          </a>
                        </h3>
                        <div className="popup_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            <RenderProjectTree
                              treeData={securityTreeData}
                              translate={t}
                              tableType={false}
                              state={state}
                            />
                          </Scrollbars>
                        </div>
                      </div>
                    </div>
                  )}
                  {item.cnvdDetail && popupType === 'type_2' && (
                    <div className="card_detail_popup card_detail_popup_3">
                      <div className="popup_box">
                        <h3 className="popup_header">
                          {t('list.title.patch_information')}
                          <a
                            className="card_detail_popup_hide"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handlePopupClose(index);
                            }}
                            onKeyUp={() => {
                              return this.handlePopupClose(index);
                            }}
                          >
                            <img src={closeBtn} alt="" />
                          </a>
                        </h3>
                        <div className="popup_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            <div className="type_3">
                              {
                                item.cnvdDetail.patch_info
                                && (
                                  <Segment raised>
                                    <Label attached="top left" className="more_info_name">
                                      {t('modal.cve.patch_name')}
                                    </Label>
                                    <Header as="h3" style={{ marginTop: '20px' }}>
                                      {' '}
                                      <span>{item.cnvdDetail.patch_info.patchname}</span>
                                      {' '}
                                    </Header>
                                  </Segment>
                                )
                              }
                              {
                                item.cnvdDetail.patch_info
                                && <Message header={t('modal.cve.patch_desc')} content={item.cnvdDetail.patch_info.patchdesc} />
                              }
                              {
                                item.cnvdDetail.patch_info
                                && <Message header={t('modal.cve.patch_vuln_sol')} content={item.cnvdDetail.patch_info.vulnsolution} />
                              }
                            </div>
                          </Scrollbars>
                        </div>
                      </div>
                    </div>
                  ) }
                  {item.cnvdDetail && item.cnvdDetail.cves.length !== 0 && popupType === 'type_3' && (
                    <div className="card_detail_popup card_detail_popup_4">
                      <div className="popup_box">
                        <h3 className="popup_header">
                          {t('modal.title.related_cves')}
                          <a
                            className="card_detail_popup_hide"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handlePopupClose(index);
                            }}
                            onKeyUp={() => {
                              return this.handlePopupClose(index);
                            }}
                          >
                            <img src={closeBtn} alt="" />
                          </a>
                        </h3>
                        <div className="popup_content">
                          <Scrollbars
                            renderTrackHorizontal={() => {
                              return <div />;
                            }}
                            renderThumbHorizontal={() => {
                              return <div />;
                            }}
                          >
                            <div className="type_3">
                              {
                                item.cnvdDetail.cves && item.cnvdDetail.cves.length !== 0 ? (
                                  <dl>
                                    <dt>{t('modal.title.related_cves')}</dt>
                                    <List>
                                      {item.cnvdDetail.cves.map((cve) => {
                                        return (
                                          <List.Item className="patch_url" key={uuidv4()}>
                                            <List.Content>
                                              <a
                                                className={cx(
                                                  'nvd_link',
                                                  {
                                                    online: isOnline,
                                                  }
                                                )}
                                                onClick={isOnline ? () => { return this.handleNavigateToNvd(cve); } : null}
                                                onKeyUp={isOnline ? () => { return this.handleNavigateToNvd(cve); } : null}
                                              >
                                                {cve}
                                              </a>
                                            </List.Content>
                                          </List.Item>
                                        );
                                      })}
                                    </List>
                                  </dl>
                                ) : null
                              }
                            </div>
                          </Scrollbars>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            {error && <div className="error_log">{error}</div>}
            {isLoading && (
              <Segment>
                <Dimmer active inverted>
                  <Loader size="medium" style={{ lineHeight: '15px' }}>{t('modal.message.loading')}</Loader>
                </Dimmer>
              </Segment>
            )}
            {
              viewMode === 'list' && cnvdList.length !== 0
              && (
                <div className="clar_pagination" style={{ marginTop: '10px', textAlign: 'center' }}>
                  <Pagination
                    activePage={currentPage}
                    totalPages={totalPage}
                    onPageChange={this.handlePaginationChange}
                    //size="mini"
                    ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                    firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                    lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                    prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                    nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                  />
                  <div className="active_page">
                    <Input
                      type="number"
                      label={t('list.title.active_page')}
                      min={1}
                      value={activePage}
                      onChange={this.handleInputActivePageChange}
                      onKeyPress={this.handleActivePageChange}
                    />
                  </div>
                </div>
              )
            }
            {!hasMore && <Footer />}
          </div>
        </div>
        <ScannedFilesInfoModal
          isOpenMSF={isOpenMSF}
          closeModal={this.handleMSFClose}
          ufid={idReport}
          scannedFileIds={scannedFileIds}
          translate={t}
        />
        <Modal open={isOpenWarnModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{this.modalBody}</p>
                {
                  this.smallBody
                  && <p className="small_text">{this.smallBody}</p>
                }
                <div className="button_wrap">
                  <a
                    className="center_button"
                    style={{ cursor: 'pointer' }}
                    onClick={this.closeModal}
                    onKeyUp={this.closeModal}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(SecurityDetail))));
